module.exports = __webpack_public_path__ + "media/konnitiha.b84af531.mp3";